// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3npKf","toggle":"styles_toggle__F4E1S","preview":"styles_preview__1uJo_"};